import Vue from 'vue'
import VueRouter from 'vue-router'
import Init from '../views/Init.vue'
import AudioTest from '../views/AudioTest.vue'
import Introduction from '../views/Introduction.vue'
import Consent from '../views/Consent.vue'
import Practice from '../views/Practice.vue'
import Experiment from '../views/Experiment.vue'
import AttitudeSurvey from '../views/AttitudeSurvey.vue'
import Demographics from '../views/Demographics.vue'
import End from '../views/End.vue'
import store from "@/store";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/init'
  },
  {
    path: '/init',
    name: 'Init',
    component: Init
  },
  {
    path: '/audioTest',
    name: 'AudioTest',
    component: AudioTest
  },  
  {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction
  }, 
  {
    path: '/consent',
    name: 'Consent',
    component: Consent
  }, 
  {
    path: '/practice',
    name: 'Practice',
    component: Practice
  },    
  {
    path: '/experiment',
    name: 'Experiment',
    component: Experiment
  },
  {
    path: '/attitudeSurvey',
    name: 'AttitudeSurvey',
    component: AttitudeSurvey
  },
  {
    path: '/demographics',
    name: 'Demographics',
    component: Demographics
  },
  {
    path: '/end',
    name: 'End',
    component: End
  }  

]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }  
})


router.beforeEach((to, from, next) => {
  if(store.state.locked == true){
    next(false);
  } else {
    next();
  }
})

router.afterEach(() => {
  store.commit("setLocked", true);
})

export default router
